import { zendeskPostPutQuery, zendeskGetQuery } from 'api';
import { handleError } from 'services/ErrorService/ErrorService';

export const searchTicketsInZendeskByKeyword = async (shopName, simplrAccountId, keyword) => {
  const url = '/searchTicketsByKeyword';

  const query = { shopName, simplrAccountId, keyword };

  return await zendeskGetQuery(url, query);
};

export const getZendeskComments = async (shopName, platformTicketId, simplrAccountId) => {
  try {
    const api = `/ticket/${platformTicketId}/comments`;
    const query = { shopName, platformTicketId, simplrAccountId };

    return await zendeskGetQuery(api, query);
  } catch (error) {
    handleError({ error });
  }
};

export const getZendeskChatComments = async (platformTicketId, simplrAccountId) => {
  try {
    const api = `/getChatTicket`;
    const query = { platformTicketId, simplrAccountId };

    return await zendeskGetQuery(api, query);
  } catch (error) {
    handleError({ error });
  }
};

export const setZendeskTags = (payload) => {
  const url = '/setZendeskTags';

  return zendeskPostPutQuery('put', url, payload);
};

export const updateZendeskTicketField = (payload) => {
  const url = '/updateTicketField';

  return zendeskPostPutQuery('post', url, payload);
};

export const patchZendeskFields = (payload) => {
  const url = '/updateTicketFields';

  return zendeskPostPutQuery('patch', url, payload);
};

export const setZendeskTicketForm = (payload) => {
  const url = '/setZendeskTicketForm';

  return zendeskPostPutQuery('put', url, payload);
};

export const setDummyButtonZendeskTags = (payload) => {
  const url = '/setDummyButtonZendeskTags';

  return zendeskPostPutQuery('put', url, payload);
};

export const setZendeskChatTicketTags = (simplrAccountId, platformTicketId, conversationId, tags) => {
  const url = '/updateZendeskChatTags';

  return zendeskPostPutQuery('put', url, {
    simplrAccountId,
    platformTicketId,
    conversationId,
    tags,
  });
};
